import { useEffect, useState } from "react";
import axios from "axios";

export default function Setup2FA() {
  const [qrCode, setQrCode] = useState("");
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [email, setEmail] = useState("");  // Zustandsvariable für E-Mail

  useEffect(() => {
    // Hole die E-Mail aus der URL
    const urlParams = new URLSearchParams(window.location.search);
    const userEmail = urlParams.get("email"); // Hole E-Mail aus der URL

    if (userEmail) {
      setEmail(userEmail); // Setze die E-Mail in den Zustand
      // Hole den QR-Code vom Backend
      axios
        .get(`http://localhost:4000/api/2fa/setup?email=${userEmail}`, { withCredentials: true })
        .then((res) => setQrCode(res.data.qrCode))
        .catch(() => setError("Failed to load QR code"));
    } else {
      setError("No email provided.");
    }
  }, []);

  const verifyAndStore2FA = async () => {
    try {
      console.log("Eingegebener Code:", code);  // Überprüfe, was hier steht

      if (!email) {
        setError("No email provided for 2FA verification.");
        return;
      }

      // Sende sowohl den Code als auch die E-Mail an das Backend
      const res = await axios.post("http://localhost:4000/api/2fa/verify-setup", 
        { email, code }, // E-Mail und Code im Body senden
        { withCredentials: true }
      );

      console.log("Verification Response:", res.data);  // Logge die Antwort

      if (res.data.success) {
        // Speichern des Tokens im localStorage nach erfolgreicher 2FA-Verifizierung
        localStorage.setItem("authToken", res.data.token);  // Speichere das Token
        localStorage.setItem("email", email);  // Speichern der E-Mail-Adresse

        // Setze den Erfolg und leite weiter
        setSuccess(true);
        window.location.href = "/logs";  // Weiterleitung zur Logs-Seite
      } else {
        setError("Invalid code. Please try again.");
      }
    } catch (err) {
      console.error("Verification error:", err);
      setError("Verification failed.");
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="bg-white p-8 rounded-xl shadow-lg max-w-md w-full">
        <h1 className="text-xl font-semibold text-center text-gray-700 mb-4">
          Set up Two-Factor Authentication
        </h1>
        {/* Hier den erklärenden Text hinzufügen */}
        <p className="text-sm text-center text-gray-600 mb-4">
          Scan the QR code with your authenticator app (such as Google Authenticator or Authy)
        </p>


        {qrCode ? (
          <div className="flex justify-center mb-6">
            <img src={qrCode} alt="Scan QR Code" className="w-40 h-40" />
          </div>
        ) : (
          <p className="text-center text-sm text-gray-500 mb-6">Loading QR code...</p>
        )}

        <input
          type="text"
          placeholder="Enter 6-digit code"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") verifyAndStore2FA()
          }}
          className="w-full border border-gray-300 rounded-lg px-4 py-2 mb-4 focus:outline-none focus:ring-2 focus:ring-red-500"
        />

        <button
          onClick={verifyAndStore2FA}
          className="w-full bg-red-600 hover:bg-red-700 text-white font-semibold py-2 rounded-lg"
        >
          Confirm & Activate 2FA
        </button>

        {error && <p className="text-red-500 mt-4 text-center">{error}</p>}
        {success && <p className="text-green-600 mt-4 text-center">2FA Setup complete!</p>}
      </div>
    </div>
  );
}
